import { render, staticRenderFns } from "./ScrollToTopBtn.vue?vue&type=template&id=42c86a36"
import script from "./ScrollToTopBtn.vue?vue&type=script&lang=ts"
export * from "./ScrollToTopBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports